// extracted by mini-css-extract-plugin
export default {"hsHeader":"Header_hsHeader__I+lTU","hsNav":"Header_hsNav__ymvCd","img":"Header_img__P+FhK"};